import { createContext, useMemo, useState } from 'react';

type AnimatedTabsContextValue = {
  activeRect: DOMRect | null;
  setActiveRect: (rect: DOMRect | null) => void;
};

export const AnimatedTabsContext = createContext<AnimatedTabsContextValue | undefined>(undefined);

type Props = {
  children: React.ReactNode;
};

export function AnimatedTabsProvider({ children }: Props) {
  const [activeRect, setActiveRect] = useState<DOMRect | null>(null);
  const value = useMemo(() => ({ activeRect, setActiveRect }), [activeRect]);

  return <AnimatedTabsContext value={value}>{children}</AnimatedTabsContext>;
}
